import { render, staticRenderFns } from "./Page10.vue?vue&type=template&id=1e78c01e&scoped=true&"
import script from "./Page10.vue?vue&type=script&lang=js&"
export * from "./Page10.vue?vue&type=script&lang=js&"
import style0 from "./Page10.vue?vue&type=style&index=0&id=1e78c01e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e78c01e",
  null
  
)

export default component.exports